import React, { createContext, ReactNode, useContext } from "react";

import { Lead } from ".";

interface IProps {
	children?: ReactNode;
}

interface ILeadContextType {
	leads?: Lead[] | null;
	fetchLeadsForAccount?: (accountId: number) => any;
	existsByEmail?: (email: string) => any;
}

const LeadContext = createContext<ILeadContextType>({});

const LeadProvider = (props: IProps) => {
	const fetchLeadsForAccount = async (accountId: number) => {
		const leadData = await fetch(`/api/v1/accounts/${accountId}/leads`);
		const leads = await leadData.json();

		return Lead.fromJsonArray(leads);
	};

	const existsByEmail = async (email: string) => {
		const check = await fetch(
			`/api/v1/leads/exists-by-email?email=${email}`,
		);
		const exists = await check.json();
		return exists.result;
	};

	// pass the value in provider and return
	return (
		<LeadContext.Provider
			value={{
				fetchLeadsForAccount,
				existsByEmail,
			}}
		>
			{props.children}
		</LeadContext.Provider>
	);
};

export const useLeads = () => {
	return useContext(LeadContext);
};

const LeadConsumer = LeadContext.Consumer;
export { LeadProvider, LeadConsumer, LeadContext };
